import axios from "../axios";

export const saveAudienceApi = (data, rowId) => {
  return axios.post(`/event-audience/${rowId}`, data);
};

export const getAudienceApi = rowId => {
  return axios.get(`/event-audience/${rowId}`);
};
